export const TabEnum = {
  Import: 'Import',
  Export: 'Export',
};
export const ImportExportTypeOptionsEnum = {
  OneTimeOnly: 0,
  New: 1,
  LoadPreviouslySaved: 2,
};
export const DroppableAreaEnum = {
  Selected: 'SelectedDropArea',
  NonSelected: 'NonSelectedDropArea',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ImportExportInventoryEnum.js